import { CommonModule, NgOptimizedImage, TitleCasePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// pipes
import { DatePipe } from '@angular/common';
import { CustomTimeAgoPipe } from '@pipes/custom-time-ago.pipe';
import { EmailMaskPipe } from '@pipes/email-mask.pipe';
import { HidePhoneNumberPipe } from '@pipes/hide-phone-num.pipe';
import { RelativeDurationPipe } from '@pipes/relative-duration.pipe';
import { SafeHtmlPipe } from '@pipes/safehtml.pipe';
import { SearchFilterPipe } from '@pipes/search-filter.pipe';
import { SearchFilterPipe1 } from '@pipes/search-filters.pipe';
import { SortPipe } from '@pipes/sort.pipe';
import { SplitPipe } from '@pipes/split.pipe';
import { ThousandSeparatorPipe } from '@pipes/thousand-separator.pipe';
import { UppercaseFirstPipe } from '@pipes/uppercase-first.pipe';
import { WallClockPipe } from '@pipes/wall-clock.pipe';
import { NgPipesModule } from 'ngx-pipes';
// Directive
import { ClickOutsideDirective } from '@directive/clickoutside.directive';
import { DoubleClickDirective } from '@directive/double-click.directive';
import { DynamicComponentDirective } from '@directive/dynamic-component.directive';
import { HoverInfoHighlightDirective } from '@directive/element-highlight-info.directive';
import { DragPanDirective } from '@directive/drag-pan.directive';
import { MovableDirective } from '@directive/movable.directive';
import { OutSideClickModule } from '@directive/outside-click/outside-click.module';
import { GrabberDirective, ResizableDirective } from '@directive/resizable.directive';
import { MobileMaskDirective } from '@directive/mobile-mask.directive';
import { ThousandsMaskDirective } from '@directive/thousands-mask.directive';
import { GoogleAddressModule } from '../core/directive/google-address/google-address.module';
import { FilterPipeModule } from '../core/pipes/filter-pipe/filter.module';
import { FilterMatrixPipe } from '../core/pipes/filterMatrix.pipe';
import { TextCapitalize } from '../core/pipes/text-capitalize.pipe';

const CommonModulesList: any[] = [
  CommonModule,
  NgOptimizedImage,
  HttpClientModule,
  FormsModule,
  ReactiveFormsModule,
  NgPipesModule,
  FilterPipeModule,
  GoogleAddressModule,
  OutSideClickModule,
];

const CommonPipesList: any[] = [
  UppercaseFirstPipe,
  SortPipe,
  SafeHtmlPipe,
  SearchFilterPipe,
  SearchFilterPipe1,
  SplitPipe,
  HidePhoneNumberPipe,
  ThousandSeparatorPipe,
  EmailMaskPipe,
  TextCapitalize,
  CustomTimeAgoPipe,
  RelativeDurationPipe,
  FilterMatrixPipe,
  WallClockPipe,
];

const CommonDirectiveList: any[] = [
  ClickOutsideDirective,
  DoubleClickDirective,
  DynamicComponentDirective,
  ResizableDirective,
  GrabberDirective,
  MovableDirective,
  DragPanDirective,
  HoverInfoHighlightDirective,
  MobileMaskDirective,
];

/** Standalone directives — imported rather than declared, but re-exported the same way. */
const StandaloneDirectiveList: any[] = [ThousandsMaskDirective];

@NgModule({
  declarations: [...CommonPipesList, ...CommonDirectiveList],
  imports: [...CommonModulesList, ...StandaloneDirectiveList],
  exports: [...CommonModulesList, ...CommonPipesList, ...CommonDirectiveList, ...StandaloneDirectiveList],
  providers: [...CommonPipesList, DatePipe, TitleCasePipe],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PipeDirectiveModule {}
